import React from 'react';
import styled from 'styled-components';

const EmptySpace = styled.div`
  min-height: 10px;
`;

export default EmptySpace;
